export default "__VITE_ASSET__BbqBcgU3__"